// extracted by mini-css-extract-plugin
export default {"container":"IY-z","list":"JY-z"};